import { Link } from "react-router-dom";
import { ShieldOff } from "lucide-react";
import { useAuthStore } from "@/store/authStore";
import { permLabel } from "@/pages/rbac/rbacMeta";

/** RBAC-ENF1 · 直接输入网址进了没有权限的页面：不显示空白 / 报错，明确告诉用户并给出口。
 *  RBACROLE-1 · 知道角色名和缺的权限点时写清楚「你的角色（车辆管理员）没有「订单 · 查看列表」权限」。 */
export function NoPermissionPage({ needed }: { needed?: readonly string[] }) {
  const user = useAuthStore((s) => s.user);
  const roleNames = (user?.roleCodes ?? []).map((c) => user?.roleLabels?.[c]).filter((x): x is string => !!x);
  const perm = needed && needed.length > 0 ? permLabel(needed[0]) : null;
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-3 px-4 text-center" data-testid="no-permission">
      <ShieldOff className="h-14 w-14 text-slate-300" aria-hidden />
      <h2 className="text-xl font-semibold text-slate-900">没有权限访问这个页面</h2>
      {roleNames.length > 0 && perm ? (
        <p className="max-w-sm text-[13px] text-slate-500" data-testid="no-permission-detail">
          你的角色（{roleNames.join("、")}）没有「{perm}」权限。需要的话请找老板或技术管理员调整。
        </p>
      ) : (
        <p className="max-w-sm text-[13px] text-slate-500">
          你的账号没有这个页面需要的权限。需要的话，请联系老板或技术管理员在「权限管理」里给你的角色加上。
        </p>
      )}
      <Link to="/" className="rounded-lg bg-blue-600 px-4 py-2 text-[13px] font-semibold text-white">
        回到首页
      </Link>
    </div>
  );
}
